import React from "react";
import { CircularProgressbar } from "react-circular-progressbar";
import { useTranslation } from "react-i18next";
import Level from "../../../../../common/level/Level";
import { cutShort } from "../../../../../utils/stringUtil";
import Divider from "../../../../../common/divider/Divider";
import Box from "../../../../../common/box/Box";
import { select } from "../PreviewDocumentsUtils";

function Requests({ showTitle, state, progress, url, setSelected }) {
  const { t } = useTranslation();

  return (
    <>
      <Level className="ml-6">
        <Level.Side />
        {showTitle && <div className="title has-text-centered p-4 mr-6">{state.request.title}</div>}
        <Level.Side align="right">
          <Level.Side align="right">
            <div className="is-pulled-right" style={{ width: 100, height: 100 }}>
              <CircularProgressbar value={progress} text={`${progress}%`} />
            </div>
          </Level.Side>
        </Level.Side>
      </Level>

      <p className="is-size-6">{cutShort(state.request.info, 200, "...")}</p>
      <div className="block">
        <Divider label={t("requests.reviewDocuments.request.divider")} />
        <Box
          statusIndicatorPosition="left"
          statusIndicatorColor={state.request.color}
          className="is-size-5"
        >
          <Level className="">
            <Level.Side align="left">{state.request.pdfFormName}</Level.Side>
            <Level.Side align="right">
              <Level>
                <Level.Side align="right" className="is-flex">
                  <button
                    onClick={() => select("request", 0, null, null, setSelected)}
                    /* to={{
                      pathname: `${url}/request/0`,
                      state: { state },
                    }} */
                    rel="noopener noreferrer"
                    className="button is-pulled-left"
                  >
                    {state.color}
                    {t("requests.reviewDocuments.request.preview")}
                  </button>
                </Level.Side>
              </Level>
            </Level.Side>
          </Level>
        </Box>
      </div>
    </>
  );
}

export default Requests;
